/*
 * 获取文章内锚点 hash
 * @param anchor - 当前点击的链接元素
 */
export const getSupportArticleAnchorHash = (anchor: HTMLAnchorElement) => {
  const href = anchor.getAttribute('href') || ''
  if (href.startsWith('#')) return href

  try {
    const url = new URL(href, window.location.href)
    const currentUrl = new URL(window.location.href)
    if (url.origin === currentUrl.origin && url.pathname === currentUrl.pathname && url.search === currentUrl.search && url.hash) {
      return url.hash
    }
  } catch (err) {
    return ''
  }

  return ''
}

/*
 * 转义 CSS 属性选择器中的字符串
 * @param value - 需要查找的 id 或 name
 */
const escapeCssAttributeValue = (value: string) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')

/*
 * 解码 hash 中的锚点名称
 * @param hash - 链接中的 hash
 */
const decodeAnchorHash = (hash: string) => {
  try {
    return decodeURIComponent(hash.slice(1))
  } catch (err) {
    return hash.slice(1)
  }
}

/*
 * 处理文章内容中的页内锚点跳转
 * @param event - 点击事件对象
 * @param rootTarget - 文章内容容器、Shadow DOM 根节点或容器选择器
 */
export const handleSupportArticleAnchorClick = (event: Event, rootTarget: string | (Node & ParentNode)) => {
  const root = typeof rootTarget === 'string' ? document.querySelector<HTMLElement>(rootTarget) : rootTarget
  const target = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('a[href]') : null
  if (!root || !target || !root.contains(target)) return false

  const hash = getSupportArticleAnchorHash(target)
  if (!hash || hash === '#') return false

  event.preventDefault()
  const anchorName = escapeCssAttributeValue(decodeAnchorHash(hash))
  const anchorTarget = root.querySelector<HTMLElement>(`[id="${anchorName}"], a[name="${anchorName}"]`)
  if (!anchorTarget) return true

  anchorTarget.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  })
  return true
}
